import { Container, Link, Stack, Text } from "basis";
import { CreditCard } from "components/CreditCard/CreditCard";
import { Layout } from "components/Layout/Layout";
import { SvgInline } from "components/SvgInline/SvgInline";
import { useCliContext } from "../hooks/useCliContext";

export const UnableToIncrease = () => {
  const {
    state: { accountInfo },
  } = useCliContext();

  return (
    <Layout>
      <Layout.Header>Request a credit limit increase</Layout.Header>
      <Layout.Main>
        <Stack gap="8">
          <Container bg="grey.t05" padding="4">
            <CreditCard
              cardName={accountInfo?.cardName ?? ""}
              cardEndsWith={accountInfo?.cardEndsWith}
            />
          </Container>
          <SvgInline name="close-account" size="92" />
          <Text as="h4" textStyle="heading4">
            Thanks for your interest in increasing your credit limit
          </Text>
          <Text>
            Your account is not eligible for a credit limit increase at this
            time. Your account may become eligible in the future and you're
            welcome to check back again soon.
          </Text>
          <Link
            appearance="primary-button"
            variant="blue-button"
            width="216"
            href="/manage-account"
            newTab={false}
          >
            Manage account
          </Link>
        </Stack>
      </Layout.Main>
    </Layout>
  );
};
